// extracted by mini-css-extract-plugin
export default {"card":"ContactForm_card__DXR-q"};